import React from 'react';
import { Box, Button, DialogActions, Grid } from '@mui/material';
import InfoField from './InfoField';
import ButtonLeft from '../buttonLeft';
import ButtonEditar from '../ButtonEditar';
import { useLocation } from 'react-router-dom';

export interface InfoFieldConfig {
    key: string;
    label: string;
    value?: any;
    type?: 'text' | 'number' | 'date' | 'select';
    options?: { _id: string; designacao: string }[]; // usado no select
    editable?: boolean;
    onChange?: (value: any) => void;
    xs?: number;
    sm?: number;
}

interface InfoFieldGroupProps {
    editable?: boolean;
    data?: {};
    isEdit?: boolean | {};
    fields: InfoFieldConfig[];
    spacing?: number;
    setIsEdit?: (isEdit: boolean) => void;
    load?: boolean;
    submit?: () => void;
    variant?: 'body1' | 'body2' | 'caption' | 'h6' | 'subtitle1' | 'subtitle2';
    // handleChange?: (field: string, value: any) => void;
}

const InfoFieldGroup: React.FC<InfoFieldGroupProps> = ({
    editable = false, 
    isEdit,
    data,
    setIsEdit,
    fields,
    spacing = 2,
    load,
    submit,
    variant
    // handleChange
}) => {

    // const user = useSelector(state => state.account.user);
    const location = useLocation();
    // (location.pathname === "/meu-perfil/" || location.pathname === "/meu-perfil");
    // const isAdmin = location.pathname.includes("/admin");

    return (
        <>
            <Box sx={{ backgroundColor: 'rgba(0, 0, 0, 0.03)', padding: '2rem', borderRadius: '4px', mb: 2, position: 'relative' }}>

                {editable &&
                    <DialogActions sx={{ position: 'absolute', right: 0, top: 0 }}>
                        <ButtonEditar setEdit={setIsEdit} edit={isEdit} />
                    </DialogActions>
                }

                <Grid container spacing={spacing} >

                    {fields.map((field, index) => (
                        <InfoField
                            key={index}
                            nameInput={field.key}
                            type={field.type}
                            options={field.options}
                            label={field.label}
                            value={field.value}
                            editable={field.editable ?? isEdit}
                            // onChange={handleChange ? (value) => handleChange(field.key, value) : field.onChange}
                            onChange={field.onChange}
                            xs={field.xs}
                            sm={field.sm}
                            variant={variant}
                        />
                    ))}

                </Grid>
            </Box>

            {isEdit &&
                <ButtonLeft
                    title={'Salvar'}
                    funcao={submit}
                    load={load}
                    disabled={load || !data}
                >
                    <Button color="error" onClick={() => setIsEdit && setIsEdit(false)} >Cancelar</Button>
                </ButtonLeft>
            }

        </>
    );
};

export default InfoFieldGroup;
